import { StyleSheet } from 'react-native';

export const presentationStyles = StyleSheet.create({
  root: { flex: 1 },
  content: { flex: 1 },
  hidden: { display: 'none' },
});
